import api from "../../api";
/* eslint-disable */
export default {
  namespaced: true,
  state: {
    Color: [],
  },
  getters: {
    getColor(state) {
      return state.Color;
    },
  },
  mutations: {
    SetColor(state, data) {
      state.Color = [];
      state.Color = data;
    },
  },
  actions: {
    fetchAllColor({ commit }, payload = {}) {
      return new Promise((resolve, rej) => {
        api()
          .post(`Color/get_all_colors`, {}, {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            resolve(res);
            commit("SetColor", res.data);
          })
          .catch((err) => console.log(err));
      });
    },
    fetchColorById({ commit }, id) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `Color/get_colors_by_id`,
            {
              id: id,
            },
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            resolve(res);
            commit("SetColor", res.data);
          })
          .catch((err) => console.log(err));
      });
    },

    addColor({ dispatch }, data) {
      return new Promise((resolve, rej) => {
        api()
          .post(`Color/add_color`, data, {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },
    editColor({ dispatch }, data) {
      return new Promise((resolve, rej) => {
        api()
          .post(`Color/edite_color`, data, {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },

    deleteColor({ dispatch }, id) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `Color/delete_color`,
            { id: id },
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },
  },
};
